import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import newProject from './modules/newProject';
import campaigns from './modules/campaigns';
import chat from './modules/chat';
import dashboard from './modules/dashboard';
import dialog from './modules/dialog';
import files from './modules/files';
import filters from './modules/filters';
import help from './modules/help';
import kiw from './modules/kiw';
import kiwSingle from './modules/kiwSingle';
import metrics from './modules/metrics';
import notifications from './modules/notifications';
import pagination from './modules/pagination';
import project from './modules/project';
import projects from './modules/projects';
import quickAcceptance from './modules/quickAcceptance';
import snackbar from './modules/snackbar';
import tags from './modules/tags';
import users from './modules/users';
import commercialPrintSingle from './modules/commercialPrintSingle';
import commercialPrint from './modules/commercialPrint';
import dkoCooperation from './modules/dkoCooperation';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    newProject,
    campaigns,
    chat,
    dashboard,
    dialog,
    files,
    filters,
    help,
    kiw,
    kiwSingle,
    metrics,
    notifications,
    pagination,
    project,
    projects,
    quickAcceptance,
    snackbar,
    tags,
    users,
    commercialPrintSingle,
    commercialPrint,
    dkoCooperation,
  },

  state: {
    isLoading: false,
    isActionProcessing: false,
  },

  mutations: {
    CHANGE_LOADING_STATUS(state, loading) {
      state.isLoading = loading;
    },

    CHANGE_ACTION_STATUS(state, status) {
      state.isActionProcessing = status;
    },
  },

  actions: {
    changeLoadingStatus({ commit }, loading) {
      commit('CHANGE_LOADING_STATUS', loading);
    },

    changeActionStatus({ commit }, status) {
      commit('CHANGE_ACTION_STATUS', status);
    },
  },
});
